module.exports = function() {
  return new Worker(__webpack_public_path__ + "186f6b7dc4412f9381b5.worker.js");
};